import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { ImmigrationNavbar } from '../components/ImmigrationNavbar';
import { Footer } from '../components/Footer';
import { ArrowRightIcon, CalendarIcon, CheckIcon, MessageCircleIcon, DollarSignIcon } from 'lucide-react';
export const ImmigrationThankYou = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="font-[Inter,ui-sans-serif,system-ui] text-[#0B1220] overflow-x-hidden relative bg-gradient-to-b from-[#f8faff] to-[#f0f5ff]" data-id="element-769">
      {/* Cinematic frame markers */}
      <div className="fixed inset-x-0 top-0 h-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-770"></div>
      <div className="fixed inset-x-0 bottom-0 h-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-771"></div>
      <div className="fixed inset-y-0 left-0 w-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-772"></div>
      <div className="fixed inset-y-0 right-0 w-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-773"></div>
      {/* Dynamic background elements */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-774">
        <div className="absolute top-0 right-0 w-[80vw] h-[80vh] rounded-full bg-gradient-to-b from-[#2E6BFF]/5 to-transparent opacity-40 blur-[120px]" data-id="element-775"></div>
        <div className="absolute bottom-0 left-0 w-[70vw] h-[70vh] rounded-full bg-gradient-to-t from-[#36D1DC]/5 to-transparent opacity-40 blur-[100px]" data-id="element-776"></div>
        <motion.div className="absolute top-1/4 left-1/4 w-[50vw] h-[50vh] rounded-full bg-gradient-to-r from-[#0BB489]/5 to-transparent opacity-30 blur-[80px]" animate={{
        x: [0, 20, 0],
        y: [0, -20, 0]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }} data-id="element-777"></motion.div>
      </div>
      <ImmigrationNavbar data-id="element-778" />
      <main className="relative z-10 pt-24 pb-16" data-id="element-779">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-780">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-8 sm:p-10 border border-white/50 text-center" data-id="element-781">
            {/* Hero content */}
            <div className="mb-8" data-id="element-782">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="inline-flex items-center justify-center p-2 bg-green-50 rounded-full mb-6" data-id="element-783">
                <div className="bg-green-500 text-white p-2 rounded-full" data-id="element-784">
                  <CheckIcon className="h-6 w-6" data-id="element-785" />
                </div>
              </motion.div>
              <motion.h1 initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="text-3xl sm:text-4xl font-bold mb-4 bg-gradient-to-r from-[#0B1220] to-[#2E6BFF] bg-clip-text text-transparent leading-normal pb-1" data-id="element-786">
                Thanks for claiming your gift!
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="text-xl text-[#2E6BFF] font-medium" data-id="element-787">
                One quick step left: pick a time for a 15-minute demo with
                Pigeon Immigration.
              </motion.p>
            </div>
            {/* Body content */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="mb-6 max-w-2xl mx-auto" data-id="element-788">
              <p className="text-lg text-[#5A6376] mb-6" data-id="element-789">
                In this short call, we'll cover:
              </p>
              <div className="space-y-4 max-w-md mx-auto flex flex-col items-center" data-id="element-790">
                <div className="flex items-center" data-id="element-791">
                  <div className="bg-[#F0F5FF] p-2 rounded-full text-[#2E6BFF] mr-4 flex-shrink-0" data-id="element-792">
                    <MessageCircleIcon className="h-5 w-5" data-id="element-793" />
                  </div>
                  <p className="text-[#0B1220]" data-id="element-794">
                    A walkthrough of how Pigeon streamlines supporting evidence
                    collection for immigration law firms and their clients
                  </p>
                </div>
                <div className="flex items-center" data-id="element-795">
                  <div className="bg-[#F0F5FF] p-2 rounded-full text-[#2E6BFF] mr-4 flex-shrink-0" data-id="element-796">
                    <CalendarIcon className="h-5 w-5" data-id="element-797" />
                  </div>
                  <p className="text-[#0B1220]" data-id="element-798">14-Day Free Trial</p>
                </div>
                <div className="flex items-center" data-id="element-799">
                  <div className="bg-[#F0F5FF] p-2 rounded-full text-[#2E6BFF] mr-4 flex-shrink-0" data-id="element-800">
                    <DollarSignIcon className="h-5 w-5" data-id="element-801" />
                  </div>
                  <p className="text-[#0B1220]" data-id="element-802">Pricing and Q&A</p>
                </div>
              </div>
            </motion.div>
            {/* CTA Button - Moved up by reducing margin-bottom of content above */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="mb-6 mt-8" data-id="element-803">
              <motion.a href="https://calendly.com/pigeondocuments/15min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full text-white bg-gradient-to-r from-[#2E6BFF] to-[#36D1DC] hover:from-[#2059E2] hover:to-[#32C3CE] transition-all duration-300 shadow-[0_8px_16px_rgba(46,107,255,0.25)]" whileHover={{
              y: -2,
              boxShadow: '0 12px 20px rgba(46,107,255,0.3)'
            }} whileTap={{
              scale: 0.98
            }} data-id="element-804">
                Book 15-min Demo
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-805" />
              </motion.a>
            </motion.div>
            {/* Micro-trust text */}
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.6
          }} className="text-sm text-[#5A6376]" data-id="element-806">
              Can't find a time? Email{' '}
              <a href="mailto:info@pigeonimmigration.com" className="text-[#2E6BFF] hover:underline" data-id="element-807">
                info@pigeonimmigration.com
              </a>{' '}
              and we'll help.
            </motion.p>
          </motion.div>
        </div>
      </main>
      {/* Footer is hidden on this page */}
    </div>;
};